// import JsBarcode from 'jsbarcode' 
import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const returnPdfDetails = async (base64Logo, vm, merchant, rider) => {
  try {
    Store.commit('mutateCommonProperties', {
      loading: true
    }) 
    
    const pdfContent = [
      { image: 'data:image/png;base64,' + base64Logo, height: 70, width: 70, style: 'logo', alignment: 'left' },
      { text: 'Merchant : ' + merchant.business + ', Mobile: ' + merchant.mobile + ', Address: '+ merchant.address, style: 'org', alignment: 'left' },
      { text: 'Rider : ' + rider.name + ', Mobile: ' + rider.mobile, style: 'org', alignment: 'left' },
      { text: 'Total Order : ' + vm.length, style: 'org', alignment: 'right' }
    ]

    pdfContent.push({ text: '', style: 'space' })

    const allRows = [
      [
        { text: 'Order ID', style: 'th', alignment: 'center', bold: true },
        { text: 'Ref ID', style: 'th', alignment: 'center', bold: true },
        { text: 'Entry Date', style: 'th', alignment: 'center', bold: true },
        { text: 'Last Action Date', style: 'th', alignment: 'center', bold: true },
        { text: 'Name', style: 'th', alignment: 'center', bold: true },
        { text: 'Mobile', style: 'th', alignment: 'center', bold: true },
        { text: 'Price', style: 'th', alignment: 'center', bold: true },
        { text: 'Collected', style: 'th', alignment: 'center', bold: true },
        { text: 'Reason', style: 'th', alignment: 'center', bold: true },
        { text: 'Signature', style: 'th', alignment: 'center', bold: true }
      ]
    ]

    vm.forEach(item => {
      allRows.push([
          { text: item.id, alignment: 'center', style: 'td' },
          { text: item.ref_id, alignment: 'center', style: 'td' },
          { text: item.date, alignment: 'center', style: 'td' },
          { text: item.activity_date, alignment: 'center', style: 'td' },
          { text: item.name, alignment: 'center', style: 'td' },
          { text: item.mobile, alignment: 'center', style: 'td' },
          { text: item.price, alignment: 'center', style: 'td' },
          { text: item.collected, alignment: 'center', style: 'td' },
          { text: item.reason, alignment: 'center', style: 'td' },
          { text: '', alignment: 'center', style: 'td' }
      ])
    })

    pdfContent.push({
        table: {
            headerRows: 1,
            widths: ['13%', '10%', '11%', '11%', '11%', '13%', '6%', '8%', '16%', '10%'],
            body: allRows
        }
    })

    var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'portrait',
      footer: function (currentPage, pageCount) {
        return {
          table: {
            body: [
                [
                  { text: "Page " + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', /*margin: [0, 0, 0, 0]*/ }
                ]
            ]
          }
        };
      },
      styles: {
        th: {
          fontSize: 8,
          margin: [3, 3, 3, 3]
        },
        td: {
          fontSize: 8,
          margin: [3, 3, 3, 3]
        },
        org: {
          fontSize: 12,
          margin: [3, 3, 3, 3]
        },
        space: {
          margin: [5, 0, 0, 5]
        },
        header: {
          fontSize: 17,
          bold: true,
          margin: [0, 5, 0, 0]
        },
        logo: {
          margin: [0, 0, 0, 10]
        },
        normalText: {
          border: 0
        },
        hh: {
          fontSize: 13,
          bold: true,
          margin: [10, 10, 25, 20]
        }
      }
    }
    pdfMake.createPdf(docDefinition, null, null, null).print()
  } catch (error) {
    if (error) {
      console.log('err => ', error)
    }
  }
  Store.commit('mutateCommonProperties', {
    loading: false
  })
}

export default {
    returnPdfDetails
}
